import React, { type ReactNode } from 'react';
import { Box } from '@mui/material';

export type TabPanelProps = {
  children?: ReactNode;
  index: number;
  value: number;
  style?: React.CSSProperties;
};

/**
 * TabPanel component from [MicroLibraryCoreUI](https://dev.azure.com/orcha/MicroLibraryTemplate/_git/MicroLibraryCoreUI)
 *
 * @param {TabPanelProps} props - The props for the TabPanel component.
 */

export const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, style, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      style={style}
      {...other}
    >
      {value === index && (
        <Box
          sx={{ padding: '10px 0', display: 'flex', flexDirection: 'column' }}
        >
          {children}
        </Box>
      )}
    </div>
  );
};
